import React from "react";
import Question from "./Question.jsx";
import { connect } from "react-redux";
import {
	setRandomQuestion,
	setRandomAnswer,
	setCaseSensitife,
	setNameCasePart,
	setScoreWeight,
} from "../../../store/actions/index";

class CasePart extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: 0,
		};
	}

	setRandomQ(key) {
		var Index = this.props.case_part
			.map(function (item) {
				return item.key;
			})
			.indexOf(key);
		this.props.setRandomQuestion(Index);
	}

	setRandomAns(key) {
		var Index = this.props.case_part
			.map(function (item) {
				return item.key;
			})
			.indexOf(key);
		if (this.props.case_part[Index]?.type_name === "menjodohkan" || this.props.typeCase === "menjodohkan") {
			return;
		}
		this.props.setRandomAnswer(Index);
	}
	setSensitife(key) {
		var Index = this.props.case_part
			.map(function (item) {
				return item.key;
			})
			.indexOf(key);
		this.props.setCaseSensitife(Index);
	}

	setNameCasePart(key, event) {
		var Index = this.props.case_part
			.map(function (item) {
				return item.key;
			})
			.indexOf(key);
		let text = event.target.value;
		this.props.setNameCasePart(Index, text);
	}

	handleScoreWeightInput(key, value) {
		var Index = this.props.case_part
			.map(function (item) {
				return item.key;
			})
			.indexOf(key);
		this.props.setScoreWeight(Index, value);
	}

	getIndex = (key) => {
		var Index = this.props.case_part
			.map(function (item) {
				return item.key;
			})
			.indexOf(key);
		return Index;
	};

	render() {
		return (
			<div>
				<div className="mb-3">
					<h3 className="font-weight-bolder section-title d-inline">
						Bagian {this.props.noBab}.{" "}
						{this.props.typeCase === "uraian" ? "Uraian" : this.props.typeCase === "pilihan ganda" ? "Pilihan Ganda" : this.props.typeCase === "pilihan ganda kompleks" ? "Pilihan Ganda Kompleks" : this.props.typeCase === "pilihan ganda benar salah" ? "Pilihan Ganda Benar Salah" : this.props.typeCase === "isian singkat" ? "Isian Singkat" : "Menjodohkan"}
					</h3>
					<button
						type="submit"
						className="btn btn-gradient-danger btn-sm float-right"
						onClick={(e) => {
							this.props.handleDeletePartCase(this.props.keyID);
							e.preventDefault();
						}}
					>
						Hapus
					</button>
				</div>

				<div className="form-group row">
					<h3 className="col-sm-2 col-form-label h4 ">Nama Bab :</h3>
					<div className="col-sm-10">
						<textarea
							className="form-control darkLine"
							id="inputDesc"
							rows="3"
							placeholder="Tulis Nama Bab. Contoh: Bab Perkalian"
							value={this.props.case_part[this.getIndex(this.props.keyID)].name}
							onChange={(event) => {
								this.setNameCasePart(this.props.keyID, event);
							}}
							required
						></textarea>
					</div>
					<h3 className="col-sm-2 col-form-label h4 mt-1">Bobot Nilai :</h3>
					<div className="col-sm-10 row">
						<div className="col-sm-auto mt-4">
							<div style={{ minWidth: "300px", color: "black" }}>
								{(() => {
									const currentWeight = Number(this.props.case_part[this.getIndex(this.props.keyID)].score_weight);
									const isFirstOfType = this.props.case_part.findIndex(p => p.type_name === this.props.typeCase) === this.getIndex(this.props.keyID);
									return (
										<>
											<input 
												type="number" 
												className="form-control" 
												min="0" 
												step="1" 
												value={currentWeight} 
												onChange={(e) => this.handleScoreWeightInput(this.props.keyID, e.target.value)} 
												placeholder="Bobot per soal" 
												disabled={!isFirstOfType}
											/>
											<small className="text-muted d-block" style={{ marginTop: "5px" }}>
												{isFirstOfType 
													? "Bobot untuk setiap butir soal pada bagian ini." 
													: "Bobot dikunci mengikuti Bagian pertama dengan tipe soal yang sama."}
											</small>
										</>
									);
								})()}
							</div>
						</div>
					</div>

					<h3 className="col-sm-2 col-form-label h4 ">PIlih Opsi:</h3>
					<div className="col-sm-10 form-inline mb-4">
						<div className="form-check  mr-5">
							<input
								type="checkbox"
								className="form-check-input"
								id={`is-random-question-${this.props.keyID}`}
								onChange={() => {
									this.setRandomQ(this.props.keyID);
								}}
								checked={
									Boolean(
										this.props.case_part[this.getIndex(this.props.keyID)]
											.random_question_order &&
										this.props.case_part[this.getIndex(this.props.keyID)]
											.random_question_order !== "0" &&
										this.props.case_part[this.getIndex(this.props.keyID)]
											.random_question_order !== 0
									)
								}
							/>
							<label className="h5" htmlFor={`is-random-question-${this.props.keyID}`}><b>Acak Soal</b></label>
						</div>

						{(this.props.typeCase === "pilihan ganda benar salah" || this.props.typeCase === "menjodohkan" || this.props.typeCase === "pilihan ganda kompleks" || this.props.typeCase === "pilihan ganda") && (
							<div className="form-check mx-sm-2">
								<input
									type="checkbox"
									id={`is-random-choice-${this.props.keyID}`}
									className="form-check-input"
									disabled={this.props.typeCase === "menjodohkan"}
									onChange={() => {
										if (this.props.typeCase !== "menjodohkan") {
											this.setRandomAns(this.props.keyID);
										}
									}}
									checked={
										this.props.typeCase === "menjodohkan" ? true :
										Boolean(
											this.props.case_part[this.getIndex(this.props.keyID)]
												.random_choice_order &&
											this.props.case_part[this.getIndex(this.props.keyID)]
												.random_choice_order !== "0" &&
											this.props.case_part[this.getIndex(this.props.keyID)]
												.random_choice_order !== 0
										)
									}
								/>
								<label className="h5" htmlFor={`is-random-choice-${this.props.keyID}`}>
									<b>Acak Jawaban</b>
									{this.props.typeCase === "menjodohkan" && (
										<small className="text-muted ml-1">(Wajib diacak)</small>
									)}
								</label>
							</div>
						)}
						{this.props.typeCase === "isian singkat" && (
							<div className="form-check mx-sm-2">
								<input
									type="checkbox"
									id={`is-case-sensitive-${this.props.keyID}`}
									className="form-check-input"
									onChange={() => {
										this.setSensitife(this.props.keyID);
									}}
									checked={
										this.props.case_part[this.getIndex(this.props.keyID)]
											.is_case_sensitive === true
											? true
											: false
									}
								/>
								<label for={`is-case-sensitive-${this.props.keyID}`}><b>Case Sensitive</b></label>
							</div>
						)}
					</div>
				</div>
				<Question typeCase={this.props.typeCase} keyID={this.props.keyID} stillEmpty={this.props.stillEmpty} tipePenilaian={this.props.tipePenilaian} />
			</div>
		);
	}
}

const mapToStateToProps = (state) => {
	return {
		case_part: state.Exam.case_part,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setRandomQuestion: (index) => dispatch(setRandomQuestion(index)),
		setRandomAnswer: (index) => dispatch(setRandomAnswer(index)),
		setCaseSensitife: (index) => dispatch(setCaseSensitife(index)),
		setNameCasePart: (index, text) => dispatch(setNameCasePart(index, text)),
		setScoreWeight: (index, text) => dispatch(setScoreWeight(index, text)),
	};
};

export default connect(mapToStateToProps, mapDispatchToProps)(CasePart);
